// Updated DashboardTemplates component allowing rename and file upload/delete using Environmentfiles logic
// NOTE: This is a merged and adapted version integrating editing, renaming, and file management.

import React, { useState, useEffect, useRef } from "react";
import {
    useToast,

} from "@chakra-ui/react";
import {
    get_all_environment_Api,
    delete_environment_Api,
    delete_environment_api,
    update_environment_Api,
    get_all_environment_file_Api,
    create_environment_file_Api,
    delete_environment_file_Api,
} from "../../dashboardapi";
import styles from "./Myproject.module.css";
import templatestyle from "./TemplateModal.module.css";
import dashboardmodal from "./ProjectModal.module.css"
import Modal from "./Modal"
import { useSelector } from "react-redux";
import { useOutletContext } from 'react-router-dom';
import UploadManager from "../../components/UploadManager";

const DashboardTemplates = () => {
    const [environment, setEnvironments] = useState([]);
    const [TemplateactiveTab, TemplateSetActiveTab] = useState("create");
    const [loading, setLoading] = useState(false);
    const [TemplateName, setTemplateName] = useState("");
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [showUploadedFileDelete, setShowUploadedFileDelete] = useState(false);
    const [selectedEnv, setSelectedEnv] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [Templatedragging, TemplatesetDragging] = useState(false);
    const [TemplateinputFiles, TemplatesetInputFiles] = useState([]);
    const [editTemplateModal, seteditTemplateModal] = useState(false);
    // const [projId, setProjId] = useState("");
    const [showUploadManager, setShowUploadManager] = useState(false);   //upload manager trigger
    const [fileUploadShow, setFileUploadShow] = useState(false);    //  modal structure trigger
    const [allEnvironmentFiles, setAllEnvironmentFiles] = useState([]);
    const [search, setSearch] = useState("");
    const closeupdateref = useRef();
    const closedeleteref = useRef();
    const closeDeleteFileref = useRef();
    const { ToogleSidebars } = useOutletContext();
    useEffect(() => {
        function closeTemplateFileDelete(e) {
            if (showUploadedFileDelete && closeDeleteFileref.current && !closeDeleteFileref.current.contains(e.target)) {
                setShowUploadedFileDelete(false);
            }
        }
        document.addEventListener('mousedown', closeTemplateFileDelete);
        return () => document.removeEventListener('mousedown', closeTemplateFileDelete)
    }, [showUploadedFileDelete])

    useEffect(() => {
        function closeUpdateTemplate(e) {

            if (editTemplateModal && closeupdateref.current && !closeupdateref.current.contains(e.target)) {
                seteditTemplateModal(false)
            }
        }
        document.addEventListener('mousedown', closeUpdateTemplate);
        return () => document.removeEventListener('mousedown', closeUpdateTemplate);

    }, [editTemplateModal])

    useEffect(() => {
        function closeDeleteTemplate(e) {

            if (deleteModalOpen && closedeleteref.current && !closedeleteref.current.contains(e.target)) {
                setDeleteModalOpen(false)
            }
        }
        document.addEventListener('mousedown', closeDeleteTemplate);
        return () => document.removeEventListener('mousedown', closeDeleteTemplate);

    }, [deleteModalOpen])


    const TemplatefileInputRef = useRef(null);


    const Trigger = useSelector(state => state.EnvironmentTrigger.envTrigger)
    console.log(Trigger, "trigger");



    const toast = useToast();

    useEffect(() => {
        getAllEnvironments();

    }, [Trigger]);

    const templateIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-folder2" viewBox="0 0 16 16"><path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12.5zM2.5 3a.5.5 0 0 0-.5.5V6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3zM14 7H2v5.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5z" /></svg>

    const getAllEnvironments = async () => {
        setLoading(true);
        try {
            const response = await get_all_environment_Api();
            if (response.data) {
                setEnvironments(response.data);
            }
        } catch (err) {
            toast({ title: "Error", description: err.message || err, status: "error" });
        }
        setLoading(false);
    };


    const filteredTemplates = environment.filter((env) => {
        const text = search.toLowerCase().trim();
        return env.name.toLowerCase().trim().startsWith(text);
    }
    );


    const fetchallenvironmentfiles = async (file) => {
        setLoading(true);
        try {
            let response = await get_all_environment_file_Api(file.uuid)

            if (response.data && response.data.length > 0) {
                setAllEnvironmentFiles(response.data)
            } else {
                // toast({
                //     title: "No files Uploaded",
                //     description: "Please upload files to the environment",
                //     status: "warning",
                //     duration: 2000,
                //     isClosable: "true"
                // })
                setAllEnvironmentFiles([]);
            }
        } catch (error) {
            toast({
                title: "Problem getting Environmentfiles",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            });
            setAllEnvironmentFiles([]);
        } finally {
            setLoading(false);
        }
    };

    const TemplatehandleDragOver = (e) => {
        e.preventDefault();
        TemplatesetDragging(true); // Highlight the area when dragging files
    };

    const TemplatehandleDragLeave = () => {
        TemplatesetDragging(false); // Remove highlight when leaving
    };

    const TemplatehandleDrop = (e) => {
        e.preventDefault();
        TemplatesetDragging(false); // Remove highlight when dropping files
        const files = e.dataTransfer.files;
        TemplatehandleFiles(files); // Handle dropped files
    };

    const TemplatehandleFiles = (files) => {
        let size = 3000;
        let allowedfiles = [];
        let count = 0;
        const fileslist = Array.from(files)
        for (let n of fileslist) {
            count += (n.size * 0.001)
            if (count < size) {
                allowedfiles.push(n)
                console.log(count);
            }
        }
        if (fileslist.length !== allowedfiles.length) {
            toast({
                title: "Total Files size should be less than 3mb",
                description: "",
                duration: "2000",
                status: "warning",
                isClosable: "true"
            })
        }
        TemplatesetInputFiles(prevFiles => [...prevFiles, ...allowedfiles]);
        // TemplatesetInputFiles(allowedfiles)
    };
    const handlenewDelete = (todelete) => {
        TemplatesetInputFiles((prev) => prev.filter(file => file.name != todelete))
    }

    const TemplatehandleClick = () => {
        TemplatefileInputRef.current.click();
    }

    const TemplatehandleChange = (e) => {
        setTemplateName(e.target.value);
    }


    const handleDeleteTemplate = (item) => {
        setDeleteModalOpen(true);
        setSelectedEnv(item);
        console.log(item)
    }

    const handleenvdelete = async () => {
        try {
            console.log(selectedEnv.uuid)
            let result = await delete_environment_api(selectedEnv.uuid);
            if (result.data) {
                // console.log(result);
                toast({
                    title: "Environment deleted successfully",
                    description: result.data.message,
                    status: "success",
                    duration: 2000,
                    isClosable: "true"
                })
                getAllEnvironments();
                // fetchallenvironmentfiles();
            } else {
                console.log(result.error);

                let error = result.error.message || "An error occurred"
                toast({
                    title: "Problem deleting environment",
                    description: error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
            setDeleteModalOpen(false);
        }
        catch (error) {
            toast({
                title: "Problem deleting environment",
                description: error?.message,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const handleDelete = async (envid, fileid) => {
        console.log("deleting Templates");
        let result = await delete_environment_file_Api(envid, fileid);
        if (result.data) {
            toast({
                title: "Files deleted successfully",
                description: "",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            fetchallenvironmentfiles(selectedEnv)
            setShowUploadedFileDelete(false);
        }
        else {
            let error = result.error.message || "An error Occured"
            toast({
                title: "Problem deleting files",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })

        }
    }

    const Renametitle = async (id, name) => {
        try {
            const result = await update_environment_Api(id, name);
            if (result.data) {
                getAllEnvironments();
            } else {
                const errorMessage = result.error?.message || "An error occurred";
                toast({
                    title: "Problem updating environment",
                    description: errorMessage,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        } catch (error) {
            toast({
                title: "Problem updating environment",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const updateFiles = (e) => {
        e.preventDefault();

        if (TemplateName != selectedEnv.name) {
            Renametitle(selectedEnv.uuid, TemplateName);
        }
        if (TemplateinputFiles.length > 0) {
            setFileUploadShow(true);
            setShowUploadManager(true);
            fetchallenvironmentfiles(selectedEnv);
        } else {
            seteditTemplateModal(false)
        }
    }

    return (
        <div className={styles.product_page_outer}>
            {filteredTemplates.length < 1 ?

                <div className={styles.indivprojectouter}>
                    <div className={styles.project_heading}>
                        <div className={styles.dashboardSidebarIcon}>

                            <svg onClick={() => { if (window.innerWidth < 769) { ToogleSidebars(true) } }} width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 3H4C3.44772 3 3 3.44772 3 4V11C3 11.5523 3.44772 12 4 12H9C9.55228 12 10 11.5523 10 11V4C10 3.44772 9.55228 3 9 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M20 3H15C14.4477 3 14 3.44772 14 4V7C14 7.55228 14.4477 8 15 8H20C20.5523 8 21 7.55228 21 7V4C21 3.44772 20.5523 3 20 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M20 12H15C14.4477 12 14 12.4477 14 13V20C14 20.5523 14.4477 21 15 21H20C20.5523 21 21 20.5523 21 20V13C21 12.4477 20.5523 12 20 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M9 16H4C3.44772 16 3 16.4477 3 17V20C3 20.5523 3.44772 21 4 21H9C9.55228 21 10 20.5523 10 20V17C10 16.4477 9.55228 16 9 16Z" stroke="currentColo" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p>All Templates</p>
                        </div>

                    </div>
                    <div className={styles.Dashboardmaincontents}>


                        <div className={styles.dashboardsearchoption}>

                            <p>Templates</p>
                            <div className={styles.dashboardsearchfield}>
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.75 5.41667C0.75 6.0295 0.870707 6.63634 1.10523 7.20252C1.33975 7.76871 1.68349 8.28316 2.11683 8.7165C2.55017 9.14984 3.06462 9.49358 3.63081 9.7281C4.197 9.96263 4.80383 10.0833 5.41667 10.0833C6.0295 10.0833 6.63634 9.96263 7.20252 9.7281C7.76871 9.49358 8.28316 9.14984 8.7165 8.7165C9.14984 8.28316 9.49358 7.76871 9.7281 7.20252C9.96263 6.63634 10.0833 6.0295 10.0833 5.41667C10.0833 4.80383 9.96263 4.197 9.7281 3.63081C9.49358 3.06462 9.14984 2.55017 8.7165 2.11683C8.28316 1.68349 7.76871 1.33975 7.20252 1.10523C6.63634 0.870707 6.0295 0.75 5.41667 0.75C4.80383 0.75 4.197 0.870707 3.63081 1.10523C3.06462 1.33975 2.55017 1.68349 2.11683 2.11683C1.68349 2.55017 1.33975 3.06462 1.10523 3.63081C0.870707 4.197 0.75 4.80383 0.75 5.41667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12.75 12.75L8.75 8.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <input type='text' placeholder='Search Your Template' value={search}
                                    onChange={(e) => setSearch(e.target.value)} /></div>
                        </div>
                        <div className={styles.Nocontent}>
                            <p>No Templates</p>
                        </div>
                    </div>
                </div>


                :
                <div className={styles.indivprojectouter}>
                    <div className={styles.project_heading}>
                        <div className={styles.dashboardSidebarIcon}>
                            <svg onClick={() => { if (window.innerWidth < 769) { ToogleSidebars(true) } }} width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 3H4C3.44772 3 3 3.44772 3 4V11C3 11.5523 3.44772 12 4 12H9C9.55228 12 10 11.5523 10 11V4C10 3.44772 9.55228 3 9 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M20 3H15C14.4477 3 14 3.44772 14 4V7C14 7.55228 14.4477 8 15 8H20C20.5523 8 21 7.55228 21 7V4C21 3.44772 20.5523 3 20 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M20 12H15C14.4477 12 14 12.4477 14 13V20C14 20.5523 14.4477 21 15 21H20C20.5523 21 21 20.5523 21 20V13C21 12.4477 20.5523 12 20 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M9 16H4C3.44772 16 3 16.4477 3 17V20C3 20.5523 3.44772 21 4 21H9C9.55228 21 10 20.5523 10 20V17C10 16.4477 9.55228 16 9 16Z" stroke="currentColo" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p>All Templates</p>
                        </div>

                    </div>

                    <div className={styles.Dashboardmaincontents}>
                        <div className={styles.dashboardsearchoption}>

                            <p>Templates</p>
                            <div className={styles.dashboardsearchfield}>
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.75 5.41667C0.75 6.0295 0.870707 6.63634 1.10523 7.20252C1.33975 7.76871 1.68349 8.28316 2.11683 8.7165C2.55017 9.14984 3.06462 9.49358 3.63081 9.7281C4.197 9.96263 4.80383 10.0833 5.41667 10.0833C6.0295 10.0833 6.63634 9.96263 7.20252 9.7281C7.76871 9.49358 8.28316 9.14984 8.7165 8.7165C9.14984 8.28316 9.49358 7.76871 9.7281 7.20252C9.96263 6.63634 10.0833 6.0295 10.0833 5.41667C10.0833 4.80383 9.96263 4.197 9.7281 3.63081C9.49358 3.06462 9.14984 2.55017 8.7165 2.11683C8.28316 1.68349 7.76871 1.33975 7.20252 1.10523C6.63634 0.870707 6.0295 0.75 5.41667 0.75C4.80383 0.75 4.197 0.870707 3.63081 1.10523C3.06462 1.33975 2.55017 1.68349 2.11683 2.11683C1.68349 2.55017 1.33975 3.06462 1.10523 3.63081C0.870707 4.197 0.75 4.80383 0.75 5.41667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12.75 12.75L8.75 8.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <input type='text' placeholder='Search Your Templates' value={search}
                                    onChange={(e) => setSearch(e.target.value)} /></div>
                        </div>
                        <div className={styles.indivprojectlist}>

                            {filteredTemplates ? filteredTemplates.reverse().map((item, i) => (
                                <div key={i} className={styles.indivproject}>
                                    <div className={styles.projectContainer}>

                                        <div className={styles.nameContainer}>
                                            <div className={styles.dashboardfileicons}>{templateIcon()}</div>
                                            <div className={styles.nameanddatecontainer}>
                                                <h2>{item.name}</h2>

                                                <div className={styles.dateandproject}>

                                                    <div className={styles.dashboardDatestyle}>
                                                        <img src={process.env.PUBLIC_URL + "/NewPages/Dashboard/DateIcon.svg"} />
                                                        <p >

                                                            {new Date(item.date).toLocaleDateString("en-GB", {
                                                                day: "2-digit",
                                                                month: "short",
                                                                year: "numeric",
                                                            })}</p>
                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        <div className={styles.dashboardoptions}>

                                            <button className={styles.DashboardEditbtn} onClick={() => {
                                                setSelectedEnv(item);
                                                setTemplateName(item.name)
                                                seteditTemplateModal(true); fetchallenvironmentfiles(item)
                                            }}>Edit</button>

                                            <button className={styles.DashboardDeletebtn} onClick={() => { handleDeleteTemplate(item) }}>Delete</button>

                                        </div>
                                    </div>


                                </div>
                            )) : ""}
                        </div>
                    </div>
                </div>
            }








            {/* EDIT MODAL */}
            {/* UPDATE TEMPLATE MODAL */}
            <Modal show={editTemplateModal} >
                <div ref={closeupdateref} className={dashboardmodal.modalContainer}>
                    <div className={dashboardmodal.modalheadingContainer}>
                        <p>update Template</p>
                        <button onClick={() => seteditTemplateModal(false)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </button>
                    </div>

                    <div className={dashboardmodal.updateTemplateDivider}>
                        <div className={dashboardmodal.updateTemplateFirsthalf}>
                            <form className={dashboardmodal.formouter} method="POST" onSubmit={updateFiles} >

                                <div className={dashboardmodal.inputWrapper}>
                                    <label className={dashboardmodal.inputlables}>
                                        Templates & Files Title<span className={templatestyle.required}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="TemplateName"
                                        value={TemplateName}
                                        onChange={TemplatehandleChange}
                                        maxLength={50}
                                        placeholder="Enter Environment Name"
                                        required
                                    />
                                </div>

                                {/* FILE UPLOAD BOX */}
                                <div
                                    className={`${dashboardmodal.uploadBox} ${Templatedragging ? dashboardmodal.dragging : ""}`}
                                    onDragOver={TemplatehandleDragOver}
                                    onDragLeave={TemplatehandleDragLeave}
                                    onDrop={TemplatehandleDrop}
                                >
                                    {!Templatedragging && (
                                        <>
                                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.6665 13.3333L9.99984 10M9.99984 10L13.3332 13.3333M9.99984 10V17.5M16.6665 13.9524C17.6844 13.1117 18.3332 11.8399 18.3332 10.4167C18.3332 7.88536 16.2811 5.83333 13.7498 5.83333C13.5677 5.83333 13.3974 5.73833 13.3049 5.58145C12.2182 3.73736 10.2119 2.5 7.9165 2.5C4.46472 2.5 1.6665 5.29822 1.6665 8.75C1.6665 10.4718 2.36271 12.0309 3.48896 13.1613" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>



                                            <div className={dashboardmodal.uploadDashboardfile}>
                                                <p>
                                                    <a onClick={TemplatehandleClick}>Click to Upload</a>
                                                    or drag and drop your files here</p>
                                            </div>


                                            <input
                                                type="file"
                                                ref={TemplatefileInputRef}
                                                style={{ display: "none" }}
                                                multiple
                                                onChange={(e) => TemplatehandleFiles(e.target.files)}
                                            />
                                        </>
                                    )}

                                    {Templatedragging && <div className={dashboardmodal.dragText}>Drag your file here</div>}
                                </div>

                                {/* SHOW SELECTED FILES IF ANY */}
                                {
                                    TemplateinputFiles.length > 0 && (
                                        <>
                                            <div className={dashboardmodal.selectedList}>
                                                {TemplateinputFiles.map((file, id) => (
                                                    <div key={id} className={dashboardmodal.fileItem}>
                                                        <span>
                                                            <p>{file.name}</p>
                                                            <p className={dashboardmodal.fileMeta}>
                                                                {file.type} | {(file.size / 1024).toFixed(2)} kb
                                                            </p>
                                                        </span>
                                                        <button type="button" onClick={() => handlenewDelete(file.name)}>Remove</button>
                                                    </div>
                                                ))}
                                            </div>
                                        </>
                                    )
                                }


                                {/* Delete Functionality */}


                                <div className={dashboardmodal.actionButtons}>
                                    <button
                                        className={dashboardmodal.cancelBtn}
                                        onClick={() => { seteditTemplateModal(false); TemplatesetInputFiles([]) }}
                                    >
                                        Cancel
                                    </button>
                                    <button className={dashboardmodal.createBtn} type="submit">
                                        Update
                                    </button>
                                </div>
                            </form>
                        </div>

                        <div className={dashboardmodal.updateTemplateSecondhalf} >
                            <p style={{ marginTop: '10px', marginLeft: '10px' }}>
                                Templates & Files Title<span className={dashboardmodal.required}>*</span>
                            </p>

                            {
                                allEnvironmentFiles.length > 0 ? (<>
                                    <div className={`${dashboardmodal.selectedListExtented}`}>
                                        {
                                            allEnvironmentFiles.map((item, index) => (

                                                <div key={index} className={dashboardmodal.fileItem}>
                                                    <span>
                                                        <p>{item.name}</p>
                                                        <p className={dashboardmodal.fileMeta}>
                                                            {item.type} | {(item.size / 1024).toFixed(2)} kb
                                                        </p>
                                                    </span>

                                                    <button type="button" onClick={() => { setSelectedFile(item); setShowUploadedFileDelete(true) }} >Remove</button>
                                                </div>))}</div></>) : (<div>
                                                    <p className={dashboardmodal.nouploadfiles}> No Uploaded Files</p>

                                                </div>)
                            }

                        </div>

                    </div>






                    <Modal show={showUploadedFileDelete}>

                        <div ref={closeDeleteFileref} className={templatestyle.warningcontainer}>
                            <div className={templatestyle.TemplateHeaderContainer}>
                                <p>Remove Template File</p>
                                <button onClick={() => setShowUploadedFileDelete(false)}>

                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </button>

                            </div>
                            <div className={templatestyle.warningContent}>
                                <p>Are you sure you want to Remove this File? </p>

                            </div>
                            <div className={templatestyle.warningbuttonsection}>
                                <button className={templatestyle.cancelBtn} onClick={() => setShowUploadedFileDelete(false)}>Cancle</button>
                                <button className={templatestyle.DeleteWarningbtn} onClick={() => handleDelete(selectedEnv.uuid, selectedFile.uuid)}>Remove</button>
                            </div>

                        </div>

                    </Modal>

                </div>

            </Modal>
            <Modal show={fileUploadShow}>
                <div className={styles.modalouter1}>
                    {showUploadManager && <div><UploadManager
                        projectId={selectedEnv.uuid}
                        files={TemplateinputFiles}
                        apiFunc={create_environment_file_Api}
                        onClose={() => {
                            setShowUploadManager(false);
                            setFileUploadShow(false);
                            console.log("closed");
                            TemplatesetInputFiles([]);
                        }}
                    /></div>}
                </div>
            </Modal>






            {/* DELETE MODAL */}
            <Modal show={deleteModalOpen}>
                <div ref={closedeleteref} className={templatestyle.warningcontainer}>
                    <div className={templatestyle.TemplateHeaderContainer}>
                        <p>Delete Template</p>
                        <button onClick={() => setDeleteModalOpen(false)}>

                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>

                    </div>
                    <div className={templatestyle.warningContent}>
                        <p>Are you sure you want to delete this template? Once deleted, it cannot be restored from Trash.</p>
                    </div>
                    <div className={templatestyle.warningbuttonsection}>
                        <button className={templatestyle.cancelBtn} onClick={() => setDeleteModalOpen(false)}>Cancle</button>
                        <button className={templatestyle.DeleteWarningbtn} onClick={() => handleenvdelete()}>Delete</button>
                    </div>


                </div>

            </Modal>

        </div>
    );
};

export default DashboardTemplates;
